import { createRoutine } from 'redux-saga-routines';
import { LOAD_DATA, FILTER_DATA } from './types';

export const loadDoctors = createRoutine(LOAD_DATA);
export const filter = createRoutine(FILTER_DATA);
